import './_gtw-state-tab.sass';

import $ from 'jquery';

import Class from '../../legacy-class';

import {BottomTab} from '../../bottom-tab';
import VisibilityManager from '../../visibility-manager';
import {ThermometersView_NonReact} from '../components/thermometers-view';
import {escape_html} from '../../../../../utils';

export const gtw_mode_names = {
    off: 'Выключен',
    water: 'Водонагрев',
    floor: 'Тёплый пол',
    air: 'Комнатный',
    week: 'Недельный',
    party: 'Вечеринка',
    econom: 'Эконом',
    workday: 'Рабочий день',
    weekend: 'Выходной день',
};

const _gtw_fail_texts = {
    break_comm: 'нет связи с котлом',
    break_trp100: 'датчик температуры воды TRP100 неисправен',
    break_p_sensor: 'датчик давления воды неисправен',
    p_water_low: 'низкое давление воды',
    p_water_high: 'высокое давление воды',
    break_fuse: 'неисправен предохранитель',
    ov_heat: 'сработал контактный датчик превышения температуры',
};

export const parse_gtw_fails = (gtw_fail) => {
    if (gtw_fail == null) return [];
    return gtw_fail.map((errcode) => _gtw_fail_texts[errcode] ?? 'неизвестная ошибка');
};

const _gtw_thermostat_text = {
    na: 'не подключен',
    should_on: 'греть',
    should_off: 'не греть',
    both: 'замкнуты оба контакта',
};

export const GTWStateTab = Class(BottomTab, {
    init(ui) {
        this._ui = ui;

        // noinspection HtmlUnknownAttribute
        this._element = $(`
            <div class="ui-bottom-tab ui-gtw-state-tab" tabtitle="состояние" tabicon="ui-icon-tab-state" role="gtw-state">
                <div class="ui-cards-container">
            
                    <div class="ui-card ui-gtw-state-tab-boiler">
                        <h1>Котёл</h1>
            
                        <table>
                            <tr>
                                <th>Нагреватели</th>
                                <td role="tens"></td>
                            </tr>
                            <tr>
                                <th>Установленная t°</th>
                                <td role="t_water"></td>
                            </tr>
                            <tr>
                                <th>Заданная алгоритмом t°</th>
                                <td role="t_water_set_disp"></td>
                            </tr>
                            <tr>
                                <th>Фактическая t°</th>
                                <td role="t_water_sensor"></td>
                            </tr>
                            <tr>
                                <th>Давление воды</th>
                                <td role="p_water"></td>
                            </tr>
                            <tr role="thermostat_air_row">
                                <th>Комнатный термостат</th>
                                <td role="thermostat_air"></td>
                            </tr>
                            <tr role="thermostat_gvs_row">
                                <th>Термостат ГВС</th>
                                <td role="thermostat_gvs"></td>
                            </tr>
                        </table>
                    </div>
            
                    <div class="ui-card ui-gtw-state-tab-air">
                        <h1>Воздух</h1>
            
                        <table>
                            <tr>
                                <th>Улица</th>
                                <td role="t_air_ext_sensor"></td>
                            </tr>
                            <tr>
                                <th>Заданная t°</th>
                                <td role="t_air_set_disp"></td>
                            </tr>
                            <tr>
                                <th>Фактическая t°</th>
                                <td role="t_air_int_sensor"></td>
                            </tr>
                        </table>
                    </div>
            
                    <div class="ui-card ui-gtw-state-tab-mode">
                        <h1>Режим</h1>
            
                        <table>
                            <tr>
                                <th>Режим</th>
                                <td role="mode_current"></td>
                            </tr>
                            <tr>
                                <th>Нагрев</th>
                                <td role="heat_current"></td>
                            </tr>
                            <tr>
                                <th>Функция ГВС</th>
                                <td role="gtw_gvs"></td>
                            </tr>
                            <tr role="fails-row" class="gtw-fails">
                                <th>АВАРИЯ</th>
                                <td>
                                    <div role="fails"></div>
                                </td>
                            </tr>
                        </table>
                    </div>
            
                    <div class="ui-card ui-gtw-state-tab-network">
                        <div class="ui-card-icon ui-icon-zta-gsm-signal" role="gsm-signal"></div>
                        <h1>ZONT Expert</h1>
            
                        <table>
                            <tr>
                                <th>Связь</th>
                                <td role="network-type"></td>
                            </tr>
                            <tr>
                                <th role="gsm-operator-type"></th>
                                <td role="gsm-operator"></td>
                            </tr>
                            <tr required-caps="has_gsm_balance">
                                <th>Баланс</th>
                                <td role="gsm-balance"></td>
                            </tr>
                            <tr required-caps="has_voltage_sensor">
                                <th>Напряжение</th>
                                <td role="voltage"></td>
                            </tr>
                        </table>
                    </div>
            
                    <div class="ui-cards-container" style="max-width: 1024px; width: 100%;">
                        <div class="ui-card ui-thermostat-control-tab-thermometers" style="flex-basis: 780px">
                            <h1>Температура</h1>
                        </div>
                    </div>
                </div>
            </div>
        `);

        this._bound_handlers = {};
        for (const [prop, handler] of Object.entries(this.handlers))
            this._bound_handlers[prop] = handler.bind(this);

        this._visibility_manager = new VisibilityManager(this._element);

        this._thermometers_view = new ThermometersView_NonReact();
        this._element
            .find('.ui-thermostat-control-tab-thermometers')
            .append(this._thermometers_view.element());

        // redux events
        this._ui.store.subscribe(() => {
            const selected_id = this._ui.store.getState().devices.selected_id;
            const device = this._ui.store
                .getState()
                .devices.items.find((device) => device.id === selected_id);

            // gtw_mode
            this._role('mode_current').text(
                gtw_mode_names[device.gtw_mode?.current]?.toLowerCase() ?? 'неизвестный'
            );

            // gtw_heat
            let current;
            switch (device.gtw_heat?.current) {
                case true:
                    current = 'включен';
                    break;
                case false:
                    current = 'выключен';
                    break;
                default:
                    current = 'неизвестно';
            }
            this._role('heat_current').text(current);

            // gtw_gvs
            let gvs;
            switch (device.gtw_gvs) {
                case true:
                    gvs = 'разрешена';
                    break;
                case false:
                    gvs = 'запрещена';
                    break;
                default:
                    gvs = '';
            }
            this._role('gtw_gvs').text(gvs);

            // gtw_ten_count
            // gtw_ten_max
            this._fill_tens_redux(device);
            this._fill_tens_redux(device);

            // gtw_t_water
            this._role('t_water').text(this._format_temp(device.gtw_t_water));

            // gtw_t_water_set_disp
            this._role('t_water_set_disp').text(
                this._format_temp(device.gtw_t_water_set_disp)
            );

            // gtw_t_water_sensor
            this._role('t_water_sensor').text(
                this._format_temp(device.gtw_t_water_sensor)
            );

            // gtw_t_air_int_sensor
            this._role('t_air_int_sensor').text(
                this._format_temp(device.gtw_t_air_int_sensor)
            );

            // gtw_t_air_ext_sensor
            this._role('t_air_ext_sensor').text(
                this._format_temp(device.gtw_t_air_ext_sensor)
            );

            // gtw_t_air_set_disp
            this._role('t_air_set_disp').text(
                this._format_temp(device.gtw_t_air_set_disp)
            );

            // gtw_p_water
            this._role('p_water').text(this._format_pressure(device.gtw_p_water));

            // gtw_fail
            const fail_texts = parse_gtw_fails(device.gtw_fail);

            this._role('fails').html(
                fail_texts.map((text) => `<p>${escape_html(text)}</p>`).join('')
            );
            this._role('fails-row').toggleClass('hidden', fail_texts.length === 0);

            // gtw_thermostat_air
            // gtw_thermostat_gvs
            this._fill_thermostats_redux(device);

            // capabilities
            this._role('network-type').text(
                device?.capabilities.includes('has_wifi') ? 'Wi-Fi' : 'GSM'
            );
            this._role('gsm-operator-type').text(
                device?.capabilities.includes('has_wifi') ? 'Сеть' : 'Оператор'
            );

            // gsm_state
            const gsm_state = device.gsm_state;
            this._role('gsm-operator').text(gsm_state?.operator ?? '');
            const grade = gsm_state?.level ? parseInt(gsm_state.level / 8, 10) + 1 : 0;
            this._role('gsm-signal').attr(
                'class',
                `ui-card-icon ui-icon-zta-gsm-signal signal-${grade}`
            );

            // balance
            this._role('gsm-balance').text(device.balance?.value ?? '');

            // voltage
            this._role('voltage').text(
                device.voltage != null ? `${device.voltage} В` : 'неизвестно'
            );

            // thermometers
            this._element
                .find('.ui-thermostat-control-tab-thermometers')
                .parent()
                .toggle(device?.active_thermometers?.length > 0);
        });
    },

    element() {
        return this._element;
    },

    should_appear(device) {
        return device?.device_type()?.code?.match(/^GTW/);
    },

    _role(role) {
        return this._element.find('[role="' + role + '"]');
    },

    _format_temp(value, dflt = '') {
        if (value == null) return dflt;
        return `${parseInt(value, 10)}°`;
    },

    _format_pressure(value, dflt = '') {
        if (value == null) return dflt;
        return `${value.toFixed(1)} бар`;
    },

    _fill_tens() {
        const count = this._device.gtw_ten_count() ?? '?';
        const max = this._device.gtw_ten_max() ?? '?';
        this._role('tens').text(`${count}/${max}`);
    },

    _fill_tens_redux(device) {
        const count = device.gtw_ten_count ?? '?';
        const max = device.gtw_ten_max ?? '?';
        this._role('tens').text(`${count}/${max}`);
    },

    _fill_thermostats() {
        for (const type of ['air', 'gvs']) {
            const value = this._device[`gtw_thermostat_${type}`]();
            this._role(`thermostat_${type}_row`).toggleClass(
                'hidden',
                value == null || value === 'na'
            );
            this._role(`thermostat_${type}`).text(
                _gtw_thermostat_text[value] ?? 'неизвестно'
            );
        }
    },

    _fill_thermostats_redux(device) {
        for (const type of ['air', 'gvs']) {
            const value = device[`gtw_thermostat_${type}`];
            this._role(`thermostat_${type}_row`).toggleClass(
                'hidden',
                value == null || value === 'na'
            );
            this._role(`thermostat_${type}`).text(
                _gtw_thermostat_text[value] ?? 'неизвестно'
            );
        }
    },

    handlers: {
        gtw_mode() {
            this._role('mode_current').text(
                gtw_mode_names[this._device.gtw_mode()?.current]?.toLowerCase() ??
                    'неизвестный'
            );
        },

        gtw_heat() {
            let current;
            switch (this._device.gtw_heat()?.current) {
                case true:
                    current = 'включен';
                    break;
                case false:
                    current = 'выключен';
                    break;
                default:
                    current = 'неизвестно';
            }
            this._role('heat_current').text(current);
        },

        gtw_gvs() {
            let gvs;
            switch (this._device.gtw_gvs()) {
                case true:
                    gvs = 'разрешена';
                    break;
                case false:
                    gvs = 'запрещена';
                    break;
                default:
                    gvs = '';
            }
            this._role('gtw_gvs').text(gvs);
        },

        gtw_ten_count() {
            this._fill_tens();
        },
        gtw_ten_max() {
            this._fill_tens();
        },

        gtw_t_water() {
            this._role('t_water').text(this._format_temp(this._device.gtw_t_water()));
        },
        gtw_t_water_set_disp() {
            this._role('t_water_set_disp').text(
                this._format_temp(this._device.gtw_t_water_set_disp())
            );
        },
        gtw_t_water_sensor() {
            this._role('t_water_sensor').text(
                this._format_temp(this._device.gtw_t_water_sensor())
            );
        },

        gtw_t_air_int_sensor() {
            this._role('t_air_int_sensor').text(
                this._format_temp(this._device.gtw_t_air_int_sensor())
            );
        },
        gtw_t_air_ext_sensor() {
            this._role('t_air_ext_sensor').text(
                this._format_temp(this._device.gtw_t_air_ext_sensor())
            );
        },
        gtw_t_air_set_disp() {
            this._role('t_air_set_disp').text(
                this._format_temp(this._device.gtw_t_air_set_disp())
            );
        },

        gtw_p_water() {
            this._role('p_water').text(
                this._format_pressure(this._device.gtw_p_water())
            );
        },

        gtw_fail() {
            const fail_texts = parse_gtw_fails(this._device.gtw_fail());

            this._role('fails').html(
                fail_texts.map((text) => `<p>${escape_html(text)}</p>`).join('')
            );
            this._role('fails-row').toggleClass('hidden', fail_texts.length === 0);
        },

        gtw_thermostat_air() {
            this._fill_thermostats();
        },
        gtw_thermostat_gvs() {
            this._fill_thermostats();
        },

        capabilities() {
            this._role('network-type').text(
                this._device.has_capability('has_wifi') ? 'Wi-Fi' : 'GSM'
            );
            this._role('gsm-operator-type').text(
                this._device.has_capability('has_wifi') ? 'Сеть' : 'Оператор'
            );
        },

        gsm_state() {
            const gsm_state = this._device.gsm_state();
            this._role('gsm-operator').text(gsm_state?.operator ?? '');
            const grade = gsm_state?.level ? parseInt(gsm_state.level / 8, 10) + 1 : 0;
            this._role('gsm-signal').attr(
                'class',
                `ui-card-icon ui-icon-zta-gsm-signal signal-${grade}`
            );
        },
        balance() {
            this._role('gsm-balance').text(this._device.balance()?.value ?? '');
        },
        voltage() {
            this._role('voltage').text(
                this._device.voltage() != null
                    ? `${this._device.voltage()} В`
                    : 'неизвестно'
            );
        },

        thermometers() {
            this._element
                .find('.ui-thermostat-control-tab-thermometers')
                .parent()
                .toggle(this._device.active_thermometers().length > 0);
        },
    },
}).implement(
    Class.Properties({
        device: {
            get() {
                return this._device;
            },
            set(value) {
                this._device = value;

                this._device_bindings?.unbind();
                this._device_bindings = null;

                if (this._device) {
                    this._device_bindings = this._device.bind(this._bound_handlers);
                    for (const handler of Object.values(this._bound_handlers))
                        handler();
                }

                this._visibility_manager.device(value);

                this._thermometers_view.device(value);
            },
        },
    })
);

GTWStateTab.should_appear = GTWStateTab.prototype.should_appear;
